<template>
  <div>
    <div class="row px-4 mx-4 col-sm-10 col-lg-8 mx-auto">
      <div class="col mx-4">
        <b-form @submit="onSubmitReset">
          <b-form-input class="hidden" id="hpot" v-model="form.hpot"></b-form-input>

          <h2 class="text-left text-black">Inserisci Nuova Password</h2>

          <b-form-input
            v-model="form.password"
            type="password"
            id="password"
            required
            :state="form.password ? minRequired:null"
            placeholder="La tua password"
            class="my-4 big__input border-secondary"
          ></b-form-input>
          <b-form-input
            v-model="form.password_confirmation"
            type="password"
            id="password_confirmation"
            required
            placeholder="Conferma password"
            class="mt-4 mb-2 p-3 border-secondary big__input"
            :state="
                  form.password && form.password_confirmation == form.password
                    ? minRequired
                    : null
                "
            :class="
                  form.password !== form.password_confirmation &&
                    'border-danger'
                "
          ></b-form-input>
          <div class="row mx-auto text center pt-1">
            <p
              class="small__txt text-left"
            >*La password deve contenere un minimo di 8 caratteri ed includere almeno 1 numero, 1 maiuscola ed 1 minuscola.</p>
          </div>

          <div class="row mx-auto text center pt-1">
            <b-button
              type="submit"
              variant="secondary"
              class="font-weight-bold mx-auto"
              :disabled="disableBtn"
            >Salva Password</b-button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "reset-password",
  data() {
    return {
      form: {
        password: "",
        password_confirmation: "",
        hpot: null,
        hash: this.$route.query.hash
      },
      errorMsgs: null,
      url: this.$route.query.openverification
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    },
    minRequired: function() {
      var space = this.form.password.indexOf(" ");
      if (space < 0) {
        var strongRegex = new RegExp(
          "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
        );
        return strongRegex.test(this.form.password);
      }
      return false;
    },
    disableBtn: function() {
      if (this.minRequired) {
        if (this.form.password === this.form.password_confirmation) {
          return false;
        }
        return true;
      }
      return true;
    }
  },
  methods: {
    onSubmitReset(ev) {
      ev.preventDefault();
      //   console.log("hash", this.hash);
      if (this.form.hpot === null) {
        this.$axios
          .post(this.url, this.form)
          .then(res => {
            // console.log(res.data.data);
            // this.$store.dispatch("login", res.data.data).then(() => {
            // this.$emit("logged-in");
            //   this.$router.go();
            // });
            this.$router.push({ name: "Home" });
            return this.$emit("updated-password");
          })
          .catch(err => {
            console.log(err);
            if (err.response.status === 422) {
              this.error = true;
            }
          });
      }
    }
  },
  created() {}
};
</script>
<style>
.small__txt {
  font-size: 0.75rem;
}
</style>
